import {View} from 'backbone';
import _template from 'dashboard/forms/app-templates-modal-view.ejs';
import restService from 'RestService';
import constants from 'Constants';
import util from 'util/Util';
import commonService from 'CommonService';
import appService from 'AppService.js';
import Spinner from 'spin/spin';
import notificationService from 'NotificationService';

class AppTemplateView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;
        this.templates = [];
        this.categories = new Set();

        return this;
    }   

    
    getCategories(){
        return this.categories;
    }

    addCategories(tags){

        _.each(tags, tag =>{
            this.categories.add(tag);
        })
    }

    displayTemplates(){

        this.templates = JSON.parse(sessionStorage.getItem("appTemplates")).sort((t1, t2) => t1.name.toUpperCase().localeCompare(t2.name.toUpperCase()));
        const templateDialog = util.newDashboardModal("#template-gallery", { title: "Template Gallery", hideTitleBar: true, closeEsc: true, width: 1050, maxHeight: 800,closeFx: () =>{
            $("#template-gallery").dialog("destroy");
            $("#template-gallery").remove();
        } });

        $("#templates-container").html("");

        _.each(this.templates, (template) => {

            this.addCategories(template.category);

            const displayMobile = template.imgMobile && template.imgMobile !== "" ? 
            '<div class="mobile" style="background: url(data:image/png;base64,' + template.imgMobile.trim() + ') no-repeat; background-size:78px;display:"></div>' : "";

            let templateCardHTML = '<div class="template-card" data-name="' + template.name + '" data-cat="' + template.category + '" id="' + template.id + '">\
                                    <div class="desktop" style="background: url(data:image/png;base64,' + template.imgDesktop.trim() + ') no-repeat; background-size: 290px"></div>'
                                    + displayMobile +
                                    '<div class="name">' + template.name + '</div>\
                                    <div class="category">' + template.category.join(", ") + '</div>\
                                </div>';

            $("#templates-container").append($(templateCardHTML));
            
        });

        $(".template-card").off().on("click", (ev) => {
            const id = ev.currentTarget.id;
            $("#template-gallery").dialog("destroy");
            $("#template-gallery").remove();
            this.createTemplate(id);
            
        });
        
        this.setCategories();
        templateDialog.dialog('open');
        
    }

    getTemplates() {

        const spin = new Spinner().spin($(constants.CONTENT_ID).get(0));
       
       
        restService.getLibraryForms(constants.FORMS_LIBRARY_GROUP_TYPE).then((data) => {
            const templates = data.RESULT.RESPONSE.Group.Item;
            const tCount = sessionStorage.getItem("appTemplates") ? JSON.parse(sessionStorage.getItem("appTemplates")).length : 0;

            if (tCount === 0 || tCount !== templates.length) { //only if the templates have not been loaded or if the number is different
                _.each(templates, (template, index) => {

                    const templateId = template["@libraryId"];
                    const templateName = template["@name"];

                    restService.getLibraryDetails(templateId).then((templateDetails) => {
                        let templateData = JSON.parse(templateDetails.ItemInfoJSON['#cdata-section']);

                        this.templates.push({
                            name: templateName,
                            id: templateId,
                            imgDesktop: templateData.imagesDesktop[0].base64,
                            imgMobile: templateData.imagesMobile[0] ? templateData.imagesMobile[0].base64 : "",
                            description: templateData.Description,
                            category: templateData.Tags
                        });
                            
                        if (index === templates.length - 1) { //is the last item                            
                            sessionStorage.setItem("appTemplates", JSON.stringify(this.templates));  
                            this.displayTemplates();                      
                        }
                    });
                });
            }
            else{
                this.displayTemplates();
            }
        });
    }


    createTemplate(id){
        restService.importLibrary(id).then((response)=> {
           
            console.log('App "'+ response.formName + '", ID "' + response.formId + '" created.');

            sessionStorage.setItem('appTourTag', '_tWalk');

            commonService.getModel(response.formId, "app", appService.createNewModel).then((appModel) => {
                commonService.loadDesigner(appModel, "app");
            });

        }).catch((error)=>{
            notificationService.error( 'There was an error creating the app. Please contact your administrator.' );
            console.log(error);
        })
    }

    setCategories(){

        let cats = Array.from(this.getCategories()).sort();
        let cHTML = "";

        cHTML += '<li><a data-cat="all" class="selected" >All</a></li>';
        _.each(cats, (category) =>{
            cHTML += '<li><a data-cat="' + category.toLowerCase() + '">' + category + '</a></li>';
        });

        $(".template-categories").html(cHTML);

        $(".template-categories li a").on("click", (ev) =>{
            ev.preventDefault();
            $(".selected").removeClass("selected");

            const $el = $(ev.currentTarget);
            $el.addClass("selected");

            this.filterTemplates();
        });
    }

    bindEvents(){

        $(".search-template").on('keyup', (e) => {

            const val = e.currentTarget.value;         
            
            if (e.key === 'Enter' || e.code === 13) {
                if(val.length > 0){
                    $(".clear-templ-search").show();                
                }
                else{
                    $(".clear-templ-search").hide();
                }

                this.filterTemplates();
            }
        });

        let enterEvent = $.Event("keyup")
        enterEvent.code = 13;

        $(".clear-templ-search").on("click", () => {
            $(".search-template").val("");
            $(".search-template").trigger(enterEvent);
        });
    }

    filterTemplates(){

        let filtered;

        const nameSearch = $(".search-template").val();
        const selectedCat = $(".template-categories a.selected").data("cat");
       
        $(".template-card").hide();
        
        filtered = $(".template-card").filter(function () { 
            let showC = true;
            let showN = true;

            if(selectedCat !== "all"){
                showC = $(this).data('cat').toLowerCase().indexOf(selectedCat) > -1;
            }

            if(nameSearch && nameSearch !== ""){
                const expr = new RegExp(`${nameSearch}.*`, "i");
                const nameL = $(this).data("name");
                showN = expr.test(nameL);
            }
            
            return showN && showC;
        });

        if(!filtered.length){
            $("#templates-container").hide();
            $(".templates-no-results").show();
        }
        else{
            $("#templates-container").show();
            $(".templates-no-results").hide();

            filtered.show();
        }   
    }

    render() {
        this.$el.html(this.template());

        this.getTemplates();
        this.bindEvents();

        this.delegateEvents();
        return this;
    }
}
export default AppTemplateView;